<template>
  <div class="popup-confirm-root">
      <!-- 遮罩层立即出现 -->
      <transition name="fade">
        <div v-if="showPopup" class="modal-overlay" @click="$emit('hidePopup');"></div>
      </transition>

      <!-- 弹出框升起动画 -->
      <transition name="slide-up">
        <div v-show="showPopup" class="modal">
          <div v-show="showHeader" class="modal-header">
            <span class="title-span">{{ title }}</span>
            <CloseIcon v-active-touch class="close-icon interactive-icon" @click.native="$emit('hidePopup');" />
          </div>
          <div class="modal-body" :class="{ scrollable: bodyScrollable }">
            <slot></slot>
          </div>
        </div>
      </transition>
  </div>
  </template>

  <script>
import CloseIcon from "@/components/icons/CloseIcon.vue";

export default {
  components: {
    CloseIcon
  },
  props: {
      title: {
        type: String,
        default: ''
      },
      showHeader: {
        type: Boolean,
        default: true
      },
      showPopup: {
        type: Boolean,
        default: true
      },
      bodyScrollable: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
      }
    }
  }
  </script>

  <style scoped>

  .popup-confirm-root {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 999;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 999;
    pointer-events: auto;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.1s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: transform 0.1s;
  }

  .slide-up-enter,
  .slide-up-leave-to {
    transform: translateY(100%);
  }

  .modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 306px;
    max-width: calc(100vw - 32px);
    padding: 30px 20px;
    box-sizing: border-box;
    border-radius: 22px;
    box-shadow: 0px 4px 4px 0px #00000040;
    z-index: 1000;
    background: #fff;
    pointer-events: auto;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 21.6px;
    letter-spacing: -0.4px;
    position: relative;
    min-height: 24px;
  }

  .title-span {
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 0 36px;
    box-sizing: border-box;
    pointer-events: none;
  }

  .close-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
    padding: 8px;
    margin: -8px -8px -8px 0;
    box-sizing: content-box;
    z-index: 1;
  }

  .modal-body {
    z-index: 999999;
  }

  .modal-body.scrollable {
    max-height: calc(100vh - 140px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .modal-header + .modal-body {
    margin-top: 20px;
  }
  </style>
